module.exports = __webpack_public_path__ + "static/media/signage-indoor-img37.43dd5686.jpg";